import compose from "@hypnosphi/recompose/compose";
import { withStyles } from "@mui/styles";
import { useState, forwardRef, useImperativeHandle, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { usePostmongerContext } from "../../../contexts/PostmongerContext";

import TextField from "apollo-react/components/TextField";
import TextEditor from "../../texteditor";
import Tooltip from "apollo-react/components/Tooltip";
import Select from "apollo-react/components/Select";
import MenuItem from "apollo-react/components/MenuItem";

const styles = {
  section: {
    marginBottom: 32,
  },
};

export const Notification = ({ classes }, ref) => {
  const { inArguments, setDirty, seedData, disabled } = usePostmongerContext();
  const { t } = useTranslation();

  const notificationPlacementOptions = 
  [
    'Account Level',
    'Account Tab',
    'Homepage'
  ];
  const defaultNotificationPlacement = inArguments.get('notificationPlacement') || 'Homepage';
  const defaultProducts = () => (inArguments.get("targetProductIds") || []);
  const [notificationTitle, setNotificationTitle] = useState(inArguments.get("notificationTitle") || "");
  const [notificationMessage, setNotificationMessage] = useState(inArguments.get("notificationMessage") || "");
  const [notificationPlacement, setNotificationPlacement] = useState(inArguments.get('notificationPlacement') || defaultNotificationPlacement);
  const [targetProducts, setTargetProducts] = useState(defaultProducts());
    
  const notificationPlacementMenuItems = notificationPlacementOptions.map(n => 
    {return <MenuItem key={n} value={n}>{n}</MenuItem>});

    
    const fields = seedData.OCEPersonal.notificationFields;
    const productsList = seedData.Products.products; //[{ Id: "001", Name: "Test 1" }, { Id: "002", Name: "Test 2" }];
  
  if (typeof inArguments.get('notificationPlacement') === "undefined")
  {
      setNotificationPlacement(defaultNotificationPlacement);
      inArguments.set("notificationPlacement", defaultNotificationPlacement);
      setDirty();
    }
    
    const GetTargetProductsMenuItems = () => {
        const items = [];
        for (let item of productsList) {
          items.push(
            <MenuItem key={item.ProductId} value={item.ProductId}>
              {item.ProductName}
            </MenuItem>
          );
        }
        return items;
    };
    const [targetProductsMenuItems, setTargetProductsMenuItems] = useState(
        GetTargetProductsMenuItems()
    );
        
    useEffect(() => {
        setTargetProductsMenuItems(GetTargetProductsMenuItems());
    }, [seedData]);
/// ON CHANGE EVENTS
  const onChangeTitle = (event) => {
    setNotificationTitle(event.target.value);
    inArguments.set("notificationTitle", event.target.value);
    setDirty();
  };

  const onChangeMsg = (event) => {
    setNotificationMessage(event.target.value);
    inArguments.set("notificationMessage", event.target.value);
    setDirty();
  };

  const onNotificationPlacementSelectChange = event =>{
    const value = event.target.value;
    inArguments.set('notificationPlacement', value);
    setNotificationPlacement(value);
    setDirty();
    }

    const onChangeTargetProducts = (event) => {
        const value = event.target.value;
        setTargetProducts(value);
        inArguments.set("targetProductIds", value);
        setDirty();
        console.log(targetProducts);
      };

    
    /// UI VALIDATION
  useImperativeHandle(ref, () => ({ isValid }));

  const isValid = () => {
    return isTitleValid() && isMsgValid();
  };

  const isTitleValid = () => {
    const title = inArguments.get("notificationTitle");
    if (title === undefined) return false;
    else if (title.length < 1) return false;
    return true;
  };

  const isMsgValid = () => {
    const msg = inArguments.get("notificationMessage");
    if (msg === undefined) return false;
    else if (msg.length < 1) return false;
    return true;
    };

  return (
    <div className={classes.section}>
      <Tooltip title={t("ocepersonal.notification.titleTooltip")}>
        <TextField
          required
          fullWidth
          label={t("ocepersonal.notification.titleCaption")}
          value={notificationTitle}
          disabled={disabled}
          error={!isTitleValid()}
          onChange={onChangeTitle}
          inputProps={{ maxLength: 255 }}
        />
      </Tooltip>
      <TextEditor
        fullWidth
        label={t("ocepersonal.notification.messageCaption")}
        tooltip={t("ocepersonal.notification.messageTooltip")}
        multiline
        required
        minRows="4"
        maxRows="4"
        value={notificationMessage}
        name="notificationMessage"
        disabled={disabled}
        onChange={onChangeMsg}
        fields={fields}
        error={!isMsgValid()}
        inputProps={{ maxLength: 32768 }}
          />
      <Tooltip title={t('ocepersonal.notification.targetProductCaption')}>
        <Select
          label={t('ocepersonal.notification.targetProductCaption')}
          multiple
          fullWidth
          onChange={onChangeTargetProducts}
          placeholder={t('ocepersonal.notification.targetProductPlaceholder')}
          disabled={disabled}
          value={targetProducts}
        >
          {targetProductsMenuItems}
        </Select>
      </Tooltip>
      <Select 
        name="notificationPlacement" 
        label={t('ocepersonl.notification.notificationPlacement')}
        value={notificationPlacement}
        fullWidth 
        disabled={disabled}
        required
        canDeselect={false}
        onChange={onNotificationPlacementSelectChange}
      >
        {notificationPlacementMenuItems}
      </Select>
    </div>
  );
};

export default compose(withStyles(styles))(forwardRef(Notification));